import { render, staticRenderFns } from "./ExamineHandle.vue?vue&type=template&id=9fca79fa&scoped=true"
import script from "./ExamineHandle.vue?vue&type=script&lang=js"
export * from "./ExamineHandle.vue?vue&type=script&lang=js"
import style0 from "./ExamineHandle.vue?vue&type=style&index=0&id=9fca79fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fca79fa",
  null
  
)

export default component.exports